<script setup lang="ts">
import { defineProps } from "vue";

defineProps({
    width: {
        type: Number,
        default: 1200,
    },
});
</script>

<template>
    <div :style="{ 'max-width': width + 'px' }" class="mx-auto">
        <slot />
    </div>
</template>
